import { render, staticRenderFns } from "./borderTitle.vue?vue&type=template&id=1f585826&scoped=true&"
import script from "./borderTitle.vue?vue&type=script&lang=js&"
export * from "./borderTitle.vue?vue&type=script&lang=js&"
import style0 from "./borderTitle.vue?vue&type=style&index=0&id=1f585826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f585826",
  null
  
)

export default component.exports